<template>
  <div class="row">
    <div class="col-md-7">
      <div class="card m-0">
        <div class="card-header p-1 bg-light">
          <div class="row">
            <div class="col-md-2">
              <label
                class="badge text-md mr-2 mb-0 align-top"
                :class="accion_ruta ? 'bg-geogo text-white' : 'bg-secondary'"
              >
                <div class="custom-control custom-checkbox">
                  <input
                    v-model="accion_ruta"
                    type="checkbox"
                    id="accion_ruta"
                    class="custom-control-input"
                    checked=""
                  />
                  <label for="accion_ruta" class="custom-control-label">
                    <i class="fas fa-edit text-xl p-1"></i>
                  </label>
                </div>
                <div class="text-center">
                  <span
                    class="badge"
                    :class="accion_ruta ? 'bg-success text-white' : 'bg-dark'"
                  >
                    Editar Ruta
                  </span>
                </div>
              </label>
            </div>
            <div class="col-md-2">
              <label
                class="badge text-md mr-2 mb-0 align-top"
                :class="viewMap.geocercas ? 'bg-info text-white' : 'bg-secondary'"
              >
                <div class="custom-control custom-checkbox">
                  <input
                    v-model="viewMap.geocercas"
                    type="checkbox"
                    id="viewMapGeocercas"
                    class="custom-control-input"
                    @change="toggleGeocercasMapa()"
                  />
                  <label for="viewMapGeocercas" class="custom-control-label">
                    <i class="fas fa-draw-polygon text-xl p-1"></i>
                  </label>
                </div>
                <div class="text-center">
                  <span
                    class="badge"
                    :class="viewMap.geocercas ? 'bg-success text-white' : 'bg-dark'"
                  >
                    Geocercas
                  </span>
                </div>
              </label>
            </div>
          </div>
        </div>
        <!-- Visualización Mapa -->
        <div class="card-body p-0">
          <gmap-map
            ref="mapaRuta"
            class="w-100"
            style="height: 500px"
            :center="viewMap.center"
            :zoom="viewMap.zoom"
            :options="{
              disableDefaultUI: true,
              zoomControl: true,
              mapTypeControl: true,
            }"
            @idle="onMapaRutaIdle"
          >
            <!-- Marcador de origen -->
            <gmap-marker
              v-if="markers.inicio_ruta"
              :position="markers.inicio_ruta.position"
              :icon="url_docs + '/' + markers.inicio_ruta.icon"
            ></gmap-marker>
            <!-- Marcador de destino -->
            <gmap-marker
              v-if="markers.fin_ruta"
              :position="markers.fin_ruta.position"
              :icon="url_docs + '/' + markers.fin_ruta.icon"
            ></gmap-marker>
            <!-- Trazado de tramos de la ruta (cuando no está en modo edición) -->
            <gmap-polyline
              v-for="(tramoRuta, index) in tramosRutaConPath"
              :key="'tramo-ruta-' + tramoRuta.id + '-' + index"
              :options="{
                strokeColor: tramoRuta.color || '#00529c',
                strokeOpacity: '0.9',
                strokeWeight: 5,
              }"
              :path="tramoRuta.path"
              @click="manejarClickTramo(tramoRuta, $event)"
            ></gmap-polyline>
            
            <!-- Trazado de tramos añadidos (cuando está en modo edición) -->
            <gmap-polyline
              v-for="(tramoAñadido, index) in tramosAñadidosConPathEdit"
              :key="'tramo-' + tramoAñadido.id + '-' + index"
              :options="{
                strokeColor: tramoAñadido.color || '#00529c',
                strokeOpacity: '0.9',
                strokeWeight: 5,
              }"
              :path="tramoAñadido.path"
              @click="manejarClickTramo(tramoAñadido, $event)"
            ></gmap-polyline>
            
            <!-- Marcadores pequeños visibles en el punto medio de cada tramo de la ruta -->
            <gmap-marker
              v-for="(tramoRuta, index) in tramosRutaConPath"
              :key="'marker-tramo-ruta-' + tramoRuta.id + '-' + index"
              :position="obtenerPuntoMedioTramo(tramoRuta)"
              :icon="googleSymbolPath ? {
                path: googleSymbolPath.CIRCLE,
                scale: 6,
                fillColor: '#00529c',
                fillOpacity: 0.6,
                strokeColor: '#FFFFFF',
                strokeWeight: 2
              } : null"
              :zIndex="1000"
              @click="mostrarHorariosTramo(tramoRuta, $event)"
            ></gmap-marker>
            
            <!-- Marcadores pequeños visibles en el punto medio de cada tramo añadido -->
            <gmap-marker
              v-for="(tramoAñadido, index) in tramosAñadidosConPathEdit"
              :key="'marker-tramo-' + tramoAñadido.id + '-' + index"
              :position="obtenerPuntoMedioTramo(tramoAñadido)"
              :icon="googleSymbolPath ? {
                path: googleSymbolPath.CIRCLE,
                scale: 6,
                fillColor: '#00529c',
                fillOpacity: 0.6,
                strokeColor: '#FFFFFF',
                strokeWeight: 2
              } : null"
              :zIndex="1000"
              @click="mostrarHorariosTramo(tramoAñadido, $event)"
            ></gmap-marker>
            
            <!-- Líneas de conexión entre tramos -->
            <gmap-polyline
              v-for="(conexion, index) in conexionesEntreTramos"
              :key="'conexion-' + index"
              :options="{
                strokeColor: '#FF9800',
                strokeOpacity: '0.8',
                strokeWeight: 3,
                icons: [{
                  icon: {
                    path: googleSymbolPath ? googleSymbolPath.FORWARD_CLOSED_ARROW : null,
                    scale: 4,
                    strokeColor: '#FF9800'
                  },
                  offset: '50%',
                  repeat: '100px'
                }]
              }"
              :path="conexion.path"
            ></gmap-polyline>
            
            <!-- Marcadores de conexión entre tramos -->
            <gmap-marker
              v-for="(conexion, index) in conexionesEntreTramos"
              :key="'marker-conexion-' + index"
              :position="conexion.position"
              :icon="{
                path: googleSymbolPath ? googleSymbolPath.CIRCLE : null,
                scale: 8,
                fillColor: '#FF9800',
                fillOpacity: 1,
                strokeColor: '#FFFFFF',
                strokeWeight: 2
              }"
            ></gmap-marker>
            
            <!-- Info Window para mostrar información de los tramos -->
            <gmap-info-window
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <div v-html="infoContent"></div>
            </gmap-info-window>
          </gmap-map>
        </div>
      </div>
    </div>
    <!-- Paneles Visualización -->
    <div class="col-md-5">
      <div class="card m-0">
        <div class="card-header bg-light p-1">
          <!-- Indicaciones -->
          <label
            v-if="ruta"
            class="badge bg-geogo text-white text-md mr-2 mb-0 text-center align-top"
            data-toggle="modal"
            data-target="#modal_indicaciones_ruta"
          >
            <div>
              <i class="fas fa-map-marked-alt text-xl p-1"></i>
            </div>
            <span class="badge bg-success">Indicaciones</span>
          </label>
        </div>
        <!-- Tabla Puntos Mapa - Solo se muestra cuando el check de editar está activo -->
        <div class="card-body table-responsive p-0" v-if="accion_ruta">
          <TramosRutas ref="TramosRutas" :accionRuta="accion_ruta"></TramosRutas>
        </div>
        <!-- Tabla de tramos cuando no está en modo edición y hay tramos -->
        <div v-else-if="tramosRuta.length > 0">
          <div class="card-header bg-primary text-white">
            <h5 class="mb-0">
              <i class="fas fa-route mr-2"></i>
              Tramos de la Ruta
              <span class="badge badge-light ml-2">{{ tramosRuta.length }}</span>
            </h5>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead class="thead-light">
                  <tr>
                    <th class="text-center" style="width: 80px;">#</th>
                    <th>Nombre del Tramo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tramo, index) in tramosRuta"
                    :key="tramo.id"
                  >
                    <td class="text-center align-middle">
                      <span class="badge badge-primary badge-pill">{{ index + 1 }}</span>
                    </td>
                    <td class="align-middle">
                      <i class="fas fa-map-marker-alt text-primary mr-2"></i>
                      <strong>{{ tramo.nombre || tramo.tramo_ruta?.nombre || 'Sin nombre' }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Mensaje cuando no está en modo edición y no hay tramos -->
        <div class="card-body p-4 text-center" v-else>
          <div class="alert alert-info mb-0">
            <i class="fas fa-info-circle mr-2"></i>
            <strong>Activa el modo "Editar Ruta"</strong> para gestionar los tramos de la ruta.
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Indicaciones Ruta -->
    <div class="modal fade" id="modal_indicaciones_ruta">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-geogo pt-2 pb-2">
            <h4 class="modal-title text-white">Indicaciones de Ruta</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <PanelIndicacionesRuta
              ref="PanelIndicacionesRuta"
            ></PanelIndicacionesRuta>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
const google = window.google;
import PanelIndicacionesRuta from "../../../../components/PanelIndicacionesRuta";
import TramosRutas from "./TramosRutas";
export default {
  name: "CsRutaDetalle",

  components: {
    PanelIndicacionesRuta,
    TramosRutas
  },

  data() {
    return {
      ruta: null,
      tipo_sitio_img: "image/iconos/default.png",
      inicio_ruta: "image/iconos/inicio_ruta.png",
      fin_ruta: "image/iconos/fin_ruta.png",
      inicio_vel_max: "image/iconos/tacom-green.png",
      fin_vel_max: "image/iconos/tacom-red.png",
      latitud_ini: 4.651371,
      longitud_ini: -74.071509,
      form: {},
      form_vel: {},
      array_vel: [],
      coords: {
        lat_origen: null,
        lng_origen: null,
        lat_destino: null,
        lng_destino: null,
      },
      viewMap: {
        zoom: 12,
        center: {
          lat: 4.651371,
          lng: -74.071509,
        },
        geocercas: false,
      },
      poligonos: [],
      circunferencias: [],
      geocercasMapShapes: [],
      markers: {
        inicio_ruta: null,
        fin_ruta: null,
        waypoints: [],
        edit_max_vel: [],
      },
      accion_ruta: false,
      accion_coordenadas: false,
      // Datos para el cuadro de información del mapa
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      addressInput: "",
      codDane: {},
      ListasForm: {
        codigosDane: [],
      },
      detCodDane: [],
      chkCodDane: false,
      url_docs: process.env.VUE_APP_API_URL,
      tramosAñadidos: [], // Tramos añadidos desde TramosRutas
      tramosRuta: [], // Tramos de la ruta obtenidos del backend
      tramoHoverActual: null, // Para el tooltip de velocidad máxima
      tooltipTimeout: null, // Para controlar el timeout del tooltip
    };
  },

  validations: {
    form_vel: {
      id: {
        required,
      },
      km_max: {
        required,
      },
    },
  },

  watch: {
    accion_ruta: function(nuevoValor) {
      // Si se desactiva el modo de edición, limpiar los tramos añadidos
      if (!nuevoValor) {
        this.tramosAñadidos = [];
        // También limpiar en el componente hijo si existe
        if (this.$refs.TramosRutas) {
          this.$refs.TramosRutas.tramosAñadidos = [];
        }
      } else {
        // Si se activa el modo de edición y hay tramos existentes, cargarlos
        if (this.tramosRuta.length > 0 && this.tramosAñadidos.length === 0) {
          // Copiar los tramos con una copia profunda para mantener el path
          this.tramosAñadidos = this.tramosRuta.map(t => {
            const tramoCopia = JSON.parse(JSON.stringify(t));
            return tramoCopia;
          });
          // Cargar también en el componente hijo
          this.$nextTick(() => {
            if (this.$refs.TramosRutas) {
              this.$refs.TramosRutas.tramosAñadidos = this.tramosRuta.map(t => {
                const tramoCopia = JSON.parse(JSON.stringify(t));
                return tramoCopia;
              });
              this.$refs.TramosRutas.obtenerPuntoReferencia();
              this.$refs.TramosRutas.filtrarTramosCercanos();
            }
          });
        }
      }
    },
  },

  computed: {
    tramosAñadidosConPath: function() {
      return this.tramosAñadidos.filter(
        (tramo) => tramo.path && tramo.path.length > 0
      );
    },
    tramosRutaConPath: function() {
      if (this.accion_ruta) {
        return []; // No mostrar tramos de la ruta cuando está en modo edición
      }
      return this.tramosRuta.filter(
        (tramo) => tramo.path && tramo.path.length > 0
      );
    },
    tramosAñadidosConPathEdit: function() {
      if (!this.accion_ruta) {
        return []; // No mostrar tramos añadidos cuando no está en modo edición
      }
      return this.tramosAñadidos.filter(
        (tramo) => tramo.path && tramo.path.length > 0
      );
    },
    conexionesEntreTramos: function() {
      const conexiones = [];
      
      // Si hay más de un tramo, crear conexiones entre ellos
      for (let i = 0; i < this.tramosAñadidos.length - 1; i++) {
        const tramoActual = this.tramosAñadidos[i];
        const tramoSiguiente = this.tramosAñadidos[i + 1];
        
        if (tramoActual.lat_destino && tramoActual.lng_destino &&
            tramoSiguiente.lat_origen && tramoSiguiente.lng_origen) {
          const destinoActual = {
            lat: parseFloat(tramoActual.lat_destino),
            lng: parseFloat(tramoActual.lng_destino),
          };
          const origenSiguiente = {
            lat: parseFloat(tramoSiguiente.lat_origen),
            lng: parseFloat(tramoSiguiente.lng_origen),
          };
          
          conexiones.push({
            path: [destinoActual, origenSiguiente],
            position: destinoActual, // Marcador en el punto de conexión
          });
        }
      }
      
      return conexiones;
    },
    googleSymbolPath() {
      if (google && google.maps && google.maps.SymbolPath) {
        return google.maps.SymbolPath;
      }
      return null;
    },
  },

  methods: {
    getIndex() {
      this.resetDatos();
      this.ruta = this.$parent.ruta ? this.$parent.ruta : null;

      if (!this.ruta) {
        return;
      }

      if (this.ruta.waypoints) {
        this.markers.waypoints = JSON.parse(this.ruta.waypoints).map(function(
          waypoint
        ) {
          return {
            location: {
              lat: parseFloat(waypoint.location.lat),
              lng: parseFloat(waypoint.location.lng),
            },
            stopover: true,
          };
        });
      } else {
        this.markers.waypoints = [];
      }

      this.tipo_sitio_img = "image/iconos/default.png";
      this.actualizarMarcadoresOrigenDestino();
      this.obtenerRutasTramos();

      if (this.viewMap.geocercas) {
        this.cargarGeocercasMapa();
      }
    },

    actualizarMarcadoresOrigenDestino() {
      if (!this.ruta) {
        return;
      }

      const origen = this.ruta.origen;
      const destino = this.ruta.destino;

      if (origen) {
        const lat = parseFloat(origen.latitud || origen.lat);
        const lng = parseFloat(origen.longitud || origen.lng || origen.lon);
        if (!isNaN(lat) && !isNaN(lng)) {
          this.markers.inicio_ruta = {
            icon: this.inicio_ruta,
            position: { lat, lng },
          };
        }
      }

      if (destino) {
        const lat = parseFloat(destino.latitud || destino.lat);
        const lng = parseFloat(destino.longitud || destino.lng || destino.lon);
        if (!isNaN(lat) && !isNaN(lng)) {
          this.markers.fin_ruta = {
            icon: this.fin_ruta,
            position: { lat, lng },
          };
        }
      }

      this.centrarMapa();
    },

    resetDatos() {
      this.ruta = null;
      this.form = {};
      this.array_vel = [];
      let reset = document.getElementsByClassName("check-tramos");
      reset.forEach(function(checkbox) {
        checkbox.checked = false;
      });

      this.viewMap = {
        zoom: 12,
        center: {
          lat: 4.651371,
          lng: -74.071509,
        },
        geocercas: false,
      };

      this.poligonos = [];
      this.circunferencias = [];
      this.limpiarGeocercasMapa();

      this.markers = {
        inicio_ruta: null,
        fin_ruta: null,
        waypoints: [],
        edit_max_vel: [],
      };
    },

    onMapaRutaIdle() {
      if (
        this.viewMap.geocercas &&
        (this.poligonos.length > 0 || this.circunferencias.length > 0) &&
        this.geocercasMapShapes.length === 0
      ) {
        this.dibujarGeocercasEnMapa();
      }
    },

    obtenerMapaGoogle() {
      if (
        this.$refs.mapaRuta &&
        this.$refs.mapaRuta.$mapObject
      ) {
        return this.$refs.mapaRuta.$mapObject;
      }
      return null;
    },

    esperarMapaListo() {
      return new Promise((resolve) => {
        let intentos = 0;
        const revisar = () => {
          const mapa = this.obtenerMapaGoogle();
          if (mapa) {
            resolve(mapa);
            return;
          }
          intentos += 1;
          if (intentos < 30) {
            setTimeout(revisar, 150);
          } else {
            resolve(null);
          }
        };
        revisar();
      });
    },

    limpiarGeocercasMapa() {
      this.geocercasMapShapes.forEach((figura) => {
        figura.setMap(null);
      });
      this.geocercasMapShapes = [];
    },

    dibujarGeocercasEnMapa() {
      this.limpiarGeocercasMapa();
      const mapa = this.obtenerMapaGoogle();
      if (!mapa || !this.viewMap.geocercas) {
        return;
      }

      if (google && google.maps && google.maps.event) {
        google.maps.event.trigger(mapa, "resize");
      }

      this.poligonos.forEach((poligono) => {
        const color = poligono.color || "#17a2b8";
        const figura = new google.maps.Polygon({
          paths: poligono.path,
          map: mapa,
          fillColor: color,
          fillOpacity: 0.35,
          strokeColor: color,
          strokeWeight: 2,
          zIndex: 2,
        });
        figura.addListener("click", (evento) => {
          this.infoWindowPos = {
            lat: evento.latLng.lat(),
            lng: evento.latLng.lng(),
          };
          this.infoContent = poligono.info;
          this.infoWinOpen = true;
          this.currentMidx = poligono.id;
        });
        this.geocercasMapShapes.push(figura);
      });

      this.circunferencias.forEach((circular) => {
        const color = circular.color || "#17a2b8";
        const figura = new google.maps.Circle({
          center: circular.center,
          radius: circular.radius,
          map: mapa,
          fillColor: color,
          fillOpacity: 0.35,
          strokeColor: color,
          strokeWeight: 2,
          zIndex: 2,
        });
        figura.addListener("click", (evento) => {
          this.infoWindowPos = {
            lat: evento.latLng.lat(),
            lng: evento.latLng.lng(),
          };
          this.infoContent = circular.info;
          this.infoWinOpen = true;
          this.currentMidx = circular.id;
        });
        this.geocercasMapShapes.push(figura);
      });
    },

    centrarMapaEnGeocercas() {
      const mapa = this.obtenerMapaGoogle();
      if (!google || !google.maps || !mapa) {
        return;
      }
      const bounds = new google.maps.LatLngBounds();
      this.poligonos.forEach((poligono) => {
        poligono.path.forEach((punto) => bounds.extend(punto));
      });
      this.circunferencias.forEach((circular) => {
        bounds.extend(circular.center);
      });
      if (!bounds.isEmpty()) {
        mapa.fitBounds(bounds);
        this.viewMap.center = bounds.getCenter().toJSON();
      }
    },

    refrescarMapa() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (!this.viewMap.geocercas) {
            this.limpiarGeocercasMapa();
            return;
          }
          this.dibujarGeocercasEnMapa();
          if (this.poligonos.length > 0 || this.circunferencias.length > 0) {
            this.centrarMapaEnGeocercas();
          }
        }, 350);
      });
    },

    cargarGeocercasMapa() {
      const rutaId = this.$route.params.id || (this.$parent && this.$parent.id);
      if (!rutaId) {
        return Promise.resolve();
      }

      return axios
        .get("/api/cs/rutas/geocercasMapa/" + rutaId)
        .then((response) => {
          this.procesarGeocercasMapa(response.data.gps_fin);
          return this.esperarMapaListo();
        })
        .then(() => {
          if (this.viewMap.geocercas) {
            this.refrescarMapa();
          }
        })
        .catch((error) => {
          this.poligonos = [];
          this.circunferencias = [];
          this.limpiarGeocercasMapa();
          this.$swal({
            icon: "error",
            title: "No se pudieron cargar las geocercas en el mapa",
            text: error.response ? String(error.response.status) : "",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },

    procesarGeocercasMapa(locations) {
      this.poligonos = [];
      this.circunferencias = [];

      if (!locations) {
        return;
      }

      if (locations.geocerca_poli) {
        locations.geocerca_poli.forEach((geocerca) => {
          if (!geocerca.puntos || geocerca.puntos.length === 0) {
            return;
          }
          const path = geocerca.puntos
            .map((punto) => ({
              lng: parseFloat(punto.longitud),
              lat: parseFloat(punto.latitud),
            }))
            .filter((punto) => !isNaN(punto.lng) && !isNaN(punto.lat));

          if (path.length > 0) {
            this.poligonos.push({
              id: geocerca.id,
              name: geocerca.desc,
              path: path,
              info: geocerca.ventana,
              color: geocerca.color,
            });
          }
        });
      }

      if (locations.geocerca_cir) {
        locations.geocerca_cir.forEach((geocerca) => {
          const lat = parseFloat(geocerca.lat);
          const lng = parseFloat(geocerca.lon);
          let radius = parseFloat(geocerca.radio);
          if (radius > 0 && radius < 50) {
            radius = radius * 1000;
          }

          if (!isNaN(lat) && !isNaN(lng) && !isNaN(radius) && radius > 0) {
            this.circunferencias.push({
              id: geocerca.id,
              center: { lat, lng },
              radius: radius,
              info: geocerca.ventana,
              color: geocerca.color,
            });
          }
        });
      }
    },

    toggleGeocercasMapa() {
      if (this.viewMap.geocercas) {
        this.cargarGeocercasMapa().then(() => {
          if (
            this.poligonos.length === 0 &&
            this.circunferencias.length === 0
          ) {
            this.$swal({
              icon: "info",
              title: "No hay geocercas asignadas a esta ruta",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        });
      } else {
        this.limpiarGeocercasMapa();
        this.infoWinOpen = false;
      }
    },

    toggleInfoWindow: function(data) {
      this.infoWindowPos = data.position;
      this.infoContent = data.html;

      //compruebe si es el mismo marcador que se seleccionó en caso afirmativo alternar
      if (this.currentMidx == data.id) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si es un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = data.id;
      }
    },

    // Funciones para el manejo general del mapa
    centrarMapa() {
      // Verificar que los marcadores existan y tengan posición
      if (this.markers.inicio_ruta && this.markers.inicio_ruta.position && 
          this.markers.fin_ruta && this.markers.fin_ruta.position) {
        const inicio = this.markers.inicio_ruta.position;
        const fin = this.markers.fin_ruta.position;
        this.viewMap.center = {
          lat: (inicio.lat + fin.lat) / 2,
          lng: (inicio.lng + fin.lng) / 2,
        };
        const distancia = this.calcularDistancia(inicio, fin);
        this.viewMap.zoom = this.calcularZoomMapa(distancia);
      } else if (this.markers.inicio_ruta && this.markers.inicio_ruta.position) {
        const inicio = this.markers.inicio_ruta.position;
        this.viewMap.center = {
          lat: inicio.lat,
          lng: inicio.lng,
        };
        this.viewMap.zoom = 12; // Zoom por defecto si solo hay origen
      } else if (this.markers.fin_ruta && this.markers.fin_ruta.position) {
        const fin = this.markers.fin_ruta.position;
        this.viewMap.center = {
          lat: fin.lat,
          lng: fin.lng,
        };
        this.viewMap.zoom = 12; // Zoom por defecto si solo hay destino
      } else {
        // Si no hay marcadores, usar coordenadas por defecto
        this.viewMap.center = {
          lat: this.latitud_ini,
          lng: this.longitud_ini,
        };
        this.viewMap.zoom = 12;
      }
    },

    calcularDistancia(origin, destination) {
      return google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(origin.lat, origin.lng),
        new google.maps.LatLng(destination.lat, destination.lng)
      );
    },

    calcularZoomMapa(distancia) {
      return Math.max(
        1,
        Math.min(Math.round(16 - Math.log2(distancia / 1000)), 18)
      );
    },

    saveMaxVel() {
      this.$parent.cargando = true;
      axios
        .put("/api/cs/rutas/saveDistancia", this.form_vel)
        .then((response) => {
          this.$parent.cargando = false;
          this.accion_ruta = false;
          this.$parent.getIndex();
          this.$refs.closeModal.click();

          this.$swal({
            icon: "success",
            title: "Se guardó exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          this.$parent.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    buscarCodigosDane(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/ciudades/lista?dato=" + search;
        axios
          .get(url)
          .then(function(response) {
            let ciudades = response.data;
            let lista = [];
            for (let i = 0; i < ciudades.length; i++) {
              const ciudad = ciudades[i];
              if (ciudad.latitud && ciudad.longitud) {
                lista.push({
                  id: ciudad.id,
                  codigo: ciudad.cod_dane + " - " + ciudad.nombre,
                  longitud: ciudad.longitud,
                  latitud: ciudad.latitud,
                });
              }
            }
            me.ListasForm.codigosDane = lista;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    // Método para pintar un tramo en el mapa
    async pintarTramoEnMapa(tramo) {
      try {
        // El tramo ya viene completo desde TramosRutas.vue
        let path = [];
        
        // Si el tramo ya tiene path, usarlo
        if (tramo.path && Array.isArray(tramo.path) && tramo.path.length > 0) {
          path = tramo.path;
        } else if (tramo.det_tramos_rutas && tramo.det_tramos_rutas.length > 0) {
          // Construir el path del tramo desde det_tramos_rutas
          tramo.det_tramos_rutas.forEach((det) => {
            if (det.orden == 1) {
              path.push({
                lat: parseFloat(det.lat_ini),
                lng: parseFloat(det.lon_ini),
              });
            }
            path.push({
              lat: parseFloat(det.lat_fin),
              lng: parseFloat(det.lon_fin),
            });
          });
        } else if (tramo.lat_origen && tramo.lng_origen && tramo.lat_destino && tramo.lng_destino) {
          // Si no hay det_tramos_rutas, crear un path simple desde origen a destino
          path = [
            { lat: parseFloat(tramo.lat_origen), lng: parseFloat(tramo.lng_origen) },
            { lat: parseFloat(tramo.lat_destino), lng: parseFloat(tramo.lng_destino) }
          ];
        }

        // Añadir el tramo con su path al array de tramos añadidos
        // Verificar si el tramo ya existe para evitar duplicados
        const tramoExistente = this.tramosAñadidos.find(t => t.id === tramo.id);
        if (!tramoExistente) {
          this.tramosAñadidos.push({
            ...tramo,
            path: path,
          });
        } else {
          // Si ya existe, actualizar su path
          const index = this.tramosAñadidos.findIndex(t => t.id === tramo.id);
          this.tramosAñadidos[index] = {
            ...this.tramosAñadidos[index],
            ...tramo,
            path: path,
          };
        }
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Ocurrió un error al cargar el tramo: " + error,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    obtenerPuntoMedioTramo(tramo) {
      if (!tramo.path || tramo.path.length === 0) {
        // Si no hay path, usar el punto medio entre origen y destino
        if (tramo.lat_origen && tramo.lng_origen && tramo.lat_destino && tramo.lng_destino) {
          return {
            lat: (parseFloat(tramo.lat_origen) + parseFloat(tramo.lat_destino)) / 2,
            lng: (parseFloat(tramo.lng_origen) + parseFloat(tramo.lng_destino)) / 2,
          };
        }
        return { lat: 0, lng: 0 };
      }
      
      // Obtener el punto medio del path
      const puntoMedio = Math.floor(tramo.path.length / 2);
      return tramo.path[puntoMedio];
    },
    
    manejarClickTramo(tramo, event) {
      // Si el click viene del polyline, mostrar velocidad máxima
      // El click en el marcador mostrará los horarios
      let position = null;
      
      if (event && event.latLng) {
        position = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
      } else {
        // Si no hay latLng en el evento, usar el punto medio del tramo
        position = this.obtenerPuntoMedioTramo(tramo);
      }
      
      const velocidadMaxima = tramo.vel_max || tramo.km_max || 'No definida';
      const contenido = `
        <div class="p-2">
          <strong>${tramo.nombre || 'Tramo'}</strong><br/>
          <small>Velocidad Máxima: <strong>${velocidadMaxima} km/h</strong></small><br/>
          <small class="text-muted" style="font-size: 10px;">Haz click en el marcador para ver horarios</small>
        </div>
      `;
      
      this.infoWindowPos = position;
      this.infoContent = contenido;
      this.infoWinOpen = true;
      this.currentMidx = `velocidad-${tramo.id}`;
      
      // Cerrar el tooltip después de 4 segundos
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }
      this.tooltipTimeout = setTimeout(() => {
        if (this.currentMidx === `velocidad-${tramo.id}`) {
          this.infoWinOpen = false;
        }
      }, 4000);
    },
    
    mostrarHorariosTramo(tramo, event) {
      // Limpiar timeout del tooltip si existe
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }
      
      // Verificar si el tramo tiene horarios
      if (!tramo.horarios || tramo.horarios.length === 0) {
        this.$swal({
          icon: "info",
          title: "Sin horarios",
          text: "Este tramo no tiene horarios configurados.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      
      // Construir el contenido HTML con los horarios
      let contenido = `
        <div class="p-2" style="max-width: 300px;">
          <h6 class="mb-2 font-weight-bold">${tramo.nombre || 'Tramo'}</h6>
          <h6 class="mb-2 text-primary">Horarios Permitidos de Tránsito</h6>
          <table class="table table-sm table-bordered" style="font-size: 12px;">
            <thead class="bg-light">
              <tr>
                <th class="text-left p-1">Día</th>
                <th class="text-left p-1">Inicio</th>
                <th class="text-left p-1">Fin</th>
              </tr>
            </thead>
            <tbody>
      `;
      
      const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      
      // Función para obtener el nombre del día
      // El backend puede usar 1-7 (1=Lunes, 7=Domingo) o 0-6 (0=Lunes, 6=Sábado, 7=Domingo)
      const obtenerNombreDia = (diaSemana) => {
        // Si es 7, es Domingo (índice 0)
        if (diaSemana === 7) {
          return 'Domingo';
        }
        // Si es 1-6, mapear a índice 1-6 (Lunes-Sábado)
        if (diaSemana >= 1 && diaSemana <= 6) {
          return diasSemana[diaSemana] || `Día ${diaSemana}`;
        }
        // Si es 0, es Lunes (índice 1)
        if (diaSemana === 0) {
          return 'Lunes';
        }
        // Fallback
        return diasSemana[diaSemana] || `Día ${diaSemana}`;
      };
      
      tramo.horarios.forEach((horario) => {
        const diaNombre = obtenerNombreDia(horario.dia_semana);
        const horarioIni = horario.horario_ini || 'N/A';
        const horarioFin = horario.horario_fin || 'N/A';
        
        contenido += `
          <tr>
            <td class="p-1">${diaNombre}</td>
            <td class="p-1">${horarioIni}</td>
            <td class="p-1">${horarioFin}</td>
          </tr>
        `;
      });
      
      contenido += `
            </tbody>
          </table>
      `;
      
      if (tramo.horarios.some(h => h.observacion)) {
        contenido += `<div class="mt-2 text-muted" style="font-size: 11px;">`;
        tramo.horarios.forEach((horario) => {
          if (horario.observacion) {
            const diaNombre = obtenerNombreDia(horario.dia_semana);
            contenido += `<p class="my-1"><strong>${diaNombre}:</strong> ${horario.observacion}</p>`;
          }
        });
        contenido += `</div>`;
      }
      
      contenido += `</div>`;
      
      this.infoWindowPos = this.obtenerPuntoMedioTramo(tramo);
      this.infoContent = contenido;
      this.infoWinOpen = true;
      this.currentMidx = `horarios-${tramo.id}`;
    },
    
    obtenerRutasTramos() {
      if (!this.ruta || !this.ruta.id) {
        return;
      }

      axios
        .get(`/api/cs/rutas/${this.ruta.id}/tramos`)
        .then((response) => {
          const tramos = response.data.data || response.data || [];
          this.tramosRuta = [];
          
          // Obtener los datos completos de cada tramo
          const promesas = tramos.map((tramo) => {
            const tramoId = tramo.tramo_ruta_id || tramo.id || tramo.tramo_ruta?.id;
            if (!tramoId) {
              console.warn('Tramo sin ID válido:', tramo);
              return Promise.resolve(null);
            }
            
            return axios.get(`/api/cs/tramosRutas/${tramoId}`)
              .then((tramoResponse) => {
                const tramoCompleto = tramoResponse.data.data || tramoResponse.data;
                // Construir el path del tramo
                let path = [];
                if (tramoCompleto.det_tramos_rutas && tramoCompleto.det_tramos_rutas.length > 0) {
                  tramoCompleto.det_tramos_rutas.forEach((det) => {
                    if (det.orden == 1) {
                      path.push({
                        lat: parseFloat(det.lat_ini),
                        lng: parseFloat(det.lon_ini),
                      });
                    }
                    path.push({
                      lat: parseFloat(det.lat_fin),
                      lng: parseFloat(det.lon_fin),
                    });
                  });
                } else if (tramoCompleto.lat_origen && tramoCompleto.lng_origen && tramoCompleto.lat_destino && tramoCompleto.lng_destino) {
                  path = [
                    { lat: parseFloat(tramoCompleto.lat_origen), lng: parseFloat(tramoCompleto.lng_origen) },
                    { lat: parseFloat(tramoCompleto.lat_destino), lng: parseFloat(tramoCompleto.lng_destino) }
                  ];
                }
                return {
                  ...tramoCompleto,
                  path: path,
                };
              })
              .catch((error) => {
                console.error(`Error al obtener tramo ${tramoId}:`, error);
                return null;
              });
          });
          
          Promise.all(promesas).then((tramosCompletos) => {
            this.tramosRuta = tramosCompletos.filter(t => t !== null);
          });
        })
        .catch((error) => {
          console.error('Error al obtener tramos de la ruta:', error);
          this.tramosRuta = [];
        });
    },
    
    editarTramoRuta(tramo, index) {
      // Activar modo edición y cargar los tramos para poder cambiarlos
      this.accion_ruta = true;
      
      // Cargar los tramos existentes en tramosAñadidos del componente padre
      // para que se muestren en el mapa (copia profunda para mantener el path)
      this.tramosAñadidos = this.tramosRuta.map(t => {
        const tramoCopia = JSON.parse(JSON.stringify(t));
        return tramoCopia;
      });
      
      // Cargar los tramos existentes en el componente TramosRutas
      this.$nextTick(() => {
        if (this.$refs.TramosRutas) {
          // Cargar los tramos de la ruta en el componente de edición
          this.$refs.TramosRutas.tramosAñadidos = this.tramosRuta.map(t => {
            const tramoCopia = JSON.parse(JSON.stringify(t));
            return tramoCopia;
          });
          // Actualizar el punto de referencia para que muestre los tramos cercanos al destino del último tramo
          this.$refs.TramosRutas.obtenerPuntoReferencia();
          this.$refs.TramosRutas.filtrarTramosCercanos();
        }
      });
    },
    
    guardarCadenaTramos(tramos) {
      this.$parent.cargando = true;

      const payload = {
        ruta_id: this.ruta.id,
        tramos_ids: tramos.map((t) => t.id),
      };

      axios
        .post("/api/cs/rutas/guardarRutasTramos", payload)
        .then((response) => {
          this.$parent.cargando = false;
          this.accion_ruta = false; // Desactivar el modo de edición
          this.$parent.getIndex();
          this.obtenerRutasTramos(); // Recargar los tramos de la ruta

          this.$swal({
            icon: "success",
            title: "Cadena de tramos guardada exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          this.$parent.cargando = false;
          const data = error.response && error.response.data;
          if (error.response && error.response.status === 422 && data && data.tramos) {
            const lista = data.tramos
              .map((t) => `• ${t.nombre} (ID ${t.id})`)
              .join("<br>");
            this.$swal.fire({
              icon: "error",
              title: "Tramos no disponibles",
              html: `${data.message}<br><br>${lista}`,
              confirmButtonText: "Entendido",
            });
            return;
          }
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
  },
  beforeDestroy() {
    // Limpiar el timeout si el componente se destruye
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
    }
    this.limpiarGeocercasMapa();
  },
};
</script>
